import React, { Component } from 'react';
import api from './api';
import CustomDataTable from './CustomDataTable';
import { FaEdit, FaTrash } from 'react-icons/fa';
import './Doctors.css';

class Branches extends Component {
  constructor(props) {
    super(props);
    this.state = {
      branches: [],
      newBranch: { status: 'active' },
      selectedBranch: null,
      isEditMode: false,
      isModalOpen: false,
    };
  }

  componentDidMount() {
    this.getBranches();
  }

  async getBranches() {
    try {
      const response = await api.get(`${process.env.REACT_APP_URL}/branches?all=true`);
      this.setState({ branches: response.data });
    } catch (error) {
      console.error('Error fetching branches:', error);
    }
  }

 validateBranchFields(branch) {
  let requiredFields = ['name', 'acr', 'address', 'status', 'phone1'];

  if (this.state.isEditMode === true) {
    requiredFields = [];
  }

  for (let i = 0; i < requiredFields.length; i++) {
    const field = requiredFields[i];
    if (!branch[field]) {
      alert(`Please fill in the ${field.toUpperCase()} field.`);
      return false;
    }
  }
  return true;
}


  handleAdd = (e) => {
    e.preventDefault();
    const { newBranch } = this.state;

    if (!this.validateBranchFields(newBranch)) return;

    api.post(`${process.env.REACT_APP_URL}/branches/add`, newBranch)
      .then(() => {
        alert('Branch added successfully');
        this.handleClose();
      })
      .catch(err => {
        console.error('Error adding branch:', err);
        alert('Error adding branch');
      });
  };

  handleUpdate = (e) => {
    e.preventDefault();
    const { selectedBranch } = this.state;

    if (!this.validateBranchFields(selectedBranch)) return;

    api.post(`${process.env.REACT_APP_URL}/branches/update/${selectedBranch._id}`, selectedBranch)
      .then(() => {
        alert('Branch updated successfully');
        this.handleClose();
      })
      .catch(err => {
        console.error('Error updating branch:', err);
        alert('Error updating branch');
      });
  };

  handleDeleteBranch = (id) => {
      const ret = window.confirm("Are you sure you want to delete this Entry ?");
    if (!ret )
      return;
    api.delete(`${process.env.REACT_APP_URL}/branches/delete/${id}`)
      .then(() => {
        alert('Branch deleted successfully');
        this.handleClose();
      })
      .catch(err => {
        console.error('Error deleting branch:', err);
        alert('Error deleting branch');
      });
  };

  handleEditBranch = (id) => {
    const branch = this.state.branches.find(b => b._id === id);
    this.setState({
      selectedBranch: { ...branch },
      isModalOpen: true,
      isEditMode: true,
    });
  };

  handleAddNewBranch = () => {
    this.setState({
      selectedBranch: null,
      newBranch: { status: 'active' },
      isEditMode: false,
      isModalOpen: true,
    });
  };

  handleClose = async () => {
    await this.getBranches();
    this.setState({
      isModalOpen: false,
      isEditMode: false,
      selectedBranch: null,
      newBranch: { status: 'active' },
    });
  };

  handleFieldChange = (field, value) => {
    if (this.state.isEditMode) {
      this.setState(prev => ({
        selectedBranch: { ...prev.selectedBranch, [field]: value }
      }));
    } else {
      this.setState(prev => ({
        newBranch: { ...prev.newBranch, [field]: value }
      }));
    }
  };

  render() {
    const { isModalOpen, isEditMode, selectedBranch, newBranch, branches } = this.state;

    const branchColumns = [
      { name: 'Name', selector: row => row.name, sortable: true },
      { name: 'Acronym', selector: row => row.acr, sortable: true },
      { name: 'Status', selector: row => row.status, sortable: true },
      { name: 'Address', selector: row => row.address, sortable: true },
      { name: 'Phone 1', selector: row => row.phone1, sortable: true },
      { name: 'Email 1', selector: row => row.email1, sortable: true },
      { name: 'Phone 2', selector: row => row.phone2, sortable: true },
      { name: 'Email 2', selector: row => row.email2, sortable: true },
      { name: 'Lat', selector: row => row.siteLat || '—', sortable: false },
      { name: 'Lon', selector: row => row.siteLon || '—', sortable: false },
      {
        name: 'Actions',
        cell: row => (
          <div style={{ display: 'flex', gap: '30px', alignItems: 'center' }}>
            <FaEdit onClick={() => this.handleEditBranch(row._id)} style={{ cursor: 'pointer', color: 'green' }} />
            <FaTrash onClick={() => this.handleDeleteBranch(row._id)} style={{ cursor: 'pointer', color: 'red' }} />
          </div>
        )
      }
    ];

    const formData = isEditMode ? selectedBranch || {} : newBranch;

    return (
      <div>
        {isModalOpen ? (
          <div style={{position:'fixed',inset:0,zIndex:9000,background:'rgba(15,23,42,0.6)',backdropFilter:'blur(8px)',WebkitBackdropFilter:'blur(8px)',display:'flex',alignItems:'center',justifyContent:'center',padding:16}}>
            <div style={{background:'#fff',borderRadius:20,boxShadow:'0 25px 80px rgba(0,0,0,0.25), 0 0 0 1px rgba(255,255,255,0.1)',width:'100%',maxWidth:600,maxHeight:'92vh',display:'flex',flexDirection:'column',overflow:'hidden'}}>
              {/* Header */}
              <div style={{background:'linear-gradient(135deg, #0f172a 0%, #1e40af 50%, #3b82f6 100%)',padding:'0 24px',height:56,display:'flex',alignItems:'center',gap:12,flexShrink:0}}>
                <div style={{width:32,height:32,borderRadius:10,background:'rgba(255,255,255,0.15)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:16}}>🏢</div>
                <div style={{flex:1}}>
                  <div style={{fontSize:15,fontWeight:700,color:'#fff',letterSpacing:-0.3}}>{isEditMode ? 'Edit Branch' : 'Add New Branch'}</div>
                  <div style={{fontSize:11,color:'rgba(255,255,255,0.6)',fontWeight:500}}>{isEditMode ? 'Update branch details' : 'Register a new branch location'}</div>
                </div>
                <button onClick={this.handleClose} style={{width:30,height:30,borderRadius:8,background:'rgba(255,255,255,0.1)',border:'1px solid rgba(255,255,255,0.2)',color:'#fff',fontSize:16,fontWeight:700,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}}
                  onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.2)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; }}
                >×</button>
              </div>
              {/* Body */}
              <div style={{overflowY:'auto',flex:1,padding:'24px 28px',background:'#fafbfc'}}>
                <form onSubmit={isEditMode ? this.handleUpdate : this.handleAdd}>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'18px 24px'}}>
                    <div>
                      <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Branch Name</label>
                      <input type="text" value={formData.name || ''} onChange={e => this.handleFieldChange('name', e.target.value)} disabled={isEditMode}
                        style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:isEditMode ? '#f3f4f6' : '#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}} />
                    </div>
                    <div>
                      <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Acronym</label>
                      <input type="text" value={formData.acr || ''} onChange={e => this.handleFieldChange('acr', e.target.value)} disabled={isEditMode}
                        style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:isEditMode ? '#f3f4f6' : '#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}} />
                    </div>
                    <div style={{gridColumn:'1 / -1'}}>
                      <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Address</label>
                      <input type="text" value={formData.address || ''} onChange={e => this.handleFieldChange('address', e.target.value)}
                        style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}} />
                    </div>
                    <div>
                      <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Status</label>
                      <select value={formData.status || 'inactive'} onChange={e => this.handleFieldChange('status', e.target.value)}
                        style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                    <div>
                      <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Phone 1</label>
                      <input type="text" value={formData.phone1 || ''} onChange={e => this.handleFieldChange('phone1', e.target.value)} maxLength={10} pattern="\d*"
                        style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}} />
                    </div>
                    <div>
                      <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Phone 2</label>
                      <input type="text" value={formData.phone2 || ''} onChange={e => this.handleFieldChange('phone2', e.target.value)} maxLength={10} pattern="\d*"
                        style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}} />
                    </div>
                    <div>
                      <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Email 1</label>
                      <input type="email" value={formData.email1 || ''} onChange={e => this.handleFieldChange('email1', e.target.value)}
                        style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}} />
                    </div>
                    <div>
                      <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Email 2</label>
                      <input type="email" value={formData.email2 || ''} onChange={e => this.handleFieldChange('email2', e.target.value)}
                        style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}} />
                    </div>
                    <div>
                      <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Site Latitude</label>
                      <input type="text" placeholder="e.g. 18.52043" value={formData.siteLat || ''} onChange={e => this.handleFieldChange('siteLat', e.target.value)}
                        style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}} />
                    </div>
                    <div>
                      <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Site Longitude</label>
                      <input type="text" placeholder="e.g. 73.85674" value={formData.siteLon || ''} onChange={e => this.handleFieldChange('siteLon', e.target.value)}
                        style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}} />
                    </div>
                  </div>
                  {/* Footer */}
                  <div style={{display:'flex',gap:12,marginTop:28,justifyContent:'flex-end'}}>
                    <button type="button" onClick={this.handleClose}
                      style={{padding:'11px 24px',borderRadius:10,border:'1.5px solid #e2e8f0',background:'#fff',color:'#64748b',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Cancel</button>
                    <button type="submit"
                      style={{padding:'11px 28px',borderRadius:10,border:'none',background:'#2563eb',color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer',boxShadow:'0 4px 14px rgba(37,99,235,0.3)',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>{isEditMode ? 'Update Branch' : 'Add Branch'}</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:12,marginBottom:20,marginTop:8}}>
              <div style={{display:'flex',alignItems:'center',gap:12}}>
                <div style={{width:42,height:42,borderRadius:12,background:'linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontSize:20,fontWeight:800,flexShrink:0}}>🏢</div>
                <div style={{fontSize:20,fontWeight:800,color:'#1e293b',letterSpacing:-0.5}}>Branches</div>
              </div>
              <button onClick={this.handleAddNewBranch}
                style={{display:'flex',alignItems:'center',gap:8,padding:'10px 20px',borderRadius:10,border:'none',background:'linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)',color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer',boxShadow:'0 4px 14px rgba(37,99,235,0.3)',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>
                + Add New Branch
              </button>
            </div>
            <CustomDataTable
              columns={branchColumns}
              data={branches}
              //selectableRows={true}
              paginationPerPage={100}
            />
          </div>
        )}
      </div>
    );
  }
}

export default Branches;
